<template>
  <span class="acoes-grid">
    <b-btn
      v-if="visibleEditar && editar"
      v-b-tooltip.hover
      title="Editar"
      variant="none"
      class="btn btn-none rounded-pill icone-acao"
      style="margin-right:0.3rem"
      @click="editar(info.row)"
    >
      <feather-icon
        icon="Edit2Icon"
        :style="info.row.empresaRegime === undefined ? 'color: #7AB795' : ''"
        size="20"
      />
    </b-btn>

    <b-btn
      v-if="visibleAtivar && ativar"
      v-b-tooltip.hover
      title="Ativar"
      variant="none"
      class="btn btn-none rounded-pill icone-acao"
      style="margin-right:0.3rem"
      @click="ativar([info.row.id])"
    >
      <font-awesome-icon
        style="margin-right:0.25rem"
        icon="fa-solid fa-building"
        class="text-success"
      />
    </b-btn>

    <b-btn
      v-if="visibleRemover && remover"
      v-b-tooltip.hover
      :title="inativar ? 'Inativar/Remover' : 'Remover'"
      variant="none"
      class="btn btn-none rounded-pill icone-acao"
      @click="remover([info.row.id])"
    >
      <feather-icon
        icon="TrashIcon"
        class="text-danger"
        size="20"
      />
    </b-btn>
  </span>
</template>

<style lang="scss">
.acoes-grid {
  display: inline-block;
}
.icone-acao {
  padding: 0.3rem;
  // width: 16px;
  // height: 16px;
}
</style>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({

  data() {
    return {
      active: false,
    }
  },

  props: {
    info: {
      type: Object,
      required: true,
    },
    visibleRemover: {
      type: Boolean,
      default: true,
    },
    visibleEditar: {
      type: Boolean,
      default: true,
    },
    visibleAtivar: {
      type: Boolean,
      default: false,
    },
    inativar: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const editar = info => {
      context.emit('editar', info)
    }

    const remover = info => {
      context.emit('remover', info)
    }

    const ativar = info => {
      context.emit('ativar', info)
    }

    return {
      editar,
      remover,
      ativar,
    }
  },

  methods: {

    show() {
      this.active = !this.active
    },
  },

})
</script>
